import { Link, useLocation } from "react-router-dom";
import React from "react";
import { Card, Col, Nav, Row } from "react-bootstrap";
import { User } from "../../../../context/AuthContext";
import { formatRoles } from "../../../../shared/utils/functions";
import { useTranslation } from "react-i18next";

const UserInfo = ({ user }: { user: User }) => {
    const location = useLocation();
    const { t } = useTranslation(); // Initialize translation hook

    return (
        <React.Fragment>
            <Col lg={5} xxl={3}>
                <Card className="overflow-hidden">
                    <Card.Body className="position-relative">
                        <div className="text-center mt-3">
                            <div className="chat-avtar d-inline-flex mx-auto">
                                <img
                                    className="rounded-circle img-fluid wid-90 hei-90 img-thumbnail object-fit-cover"
                                    src={user?.profilePicture?.path}
                                    alt={t('user.profilePictureAlt')}
                                />
                                <i className={`chat-badge ${user?.isActive ? "bg-success" : "bg-danger"} me-2 mb-2`}></i>
                            </div>
                            <h5 className="mb-0">{user?.firstName} {user?.lastName}</h5>
                            <p className="mb-0">{user?.roles && formatRoles(user.roles as any)}</p>
                        </div>
                    </Card.Body>
                    <Nav
                        variant="pills"
                        className="flex-column list-group list-group-flush account-pills mb-0"
                        id="user-set-tab"
                        role="tablist"
                        aria-orientation="vertical"
                        activeKey={location.pathname}
                    >
                        <Nav.Link
                            as={Link}
                            to="/profile-overview"
                            eventKey="/profile-overview"
                            className="list-group-item list-group-item-action"
                            id="user-set-profile-tab"
                        >
                            <span className="f-w-500">
                                <i className="ph-duotone ph-user-circle m-r-10"></i>{t('user.profileOverview')}
                            </span>
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/personal-info"
                            eventKey="/personal-info"
                            className="list-group-item list-group-item-action"
                            id="user-set-information-tab"
                        >
                            <span className="f-w-500">
                                <i className="ph-duotone ph-clipboard-text m-r-10"></i>{t('user.personalInformation')}
                            </span>
                        </Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/change-password"
                            eventKey="/change-password"
                            className="list-group-item list-group-item-action"
                            id="user-set-passwort-tab"
                        >
                            <span className="f-w-500">
                                <i className="ph-duotone ph-key m-r-10"></i>{t('user.changePassword')}
                            </span>
                        </Nav.Link>
                    </Nav>
                </Card>
                <Card>
                    <Card.Header>
                        <h5>{t('user.personalInformation')}</h5>
                    </Card.Header>
                    <Card.Body className="position-relative">
                        <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                            <p className="mb-0 text-muted me-1">{t('user.email')}</p>
                            <p className="mb-0">{user?.email}</p>
                        </div>
                        <div className="d-inline-flex align-items-center justify-content-between w-100 mb-3">
                            <p className="mb-0 text-muted me-1">{t('user.phone')}</p>
                            <p className="mb-0">{user?.contact.phone}</p>
                        </div>
                        <div className="d-inline-flex align-items-center justify-content-between w-100">
                            <p className="mb-0 text-muted me-1">{t('user.location')}</p>
                            <p className="mb-0">{user?.contact.city || t('user.notSpecified')}</p>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default UserInfo;